/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBatchResponse {
    getFixupPrototypeFunction() { return MasterAccountBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBatchResponse>): MasterAccountBatchResponse {
        let obj = Object.assign(new MasterAccountBatchResponse(), model);
        MasterAccountBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBatchResponse>): MasterAccountBatchResponse {
        if (!model) return null;
        return MasterAccountBatchResponse.newInstance(<MasterAccountBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBatchResponse) {
        if (!obj) return;

        models.MasterAccountBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBatchResponse): boolean {
        Object.setPrototypeOf(obj, MasterAccountBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.MasterAccountDetails.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.MasterAccountDetails; };

}
